<template>
    <div class="details_body">
        <ul class="details_tab">
            <li @click="num = 0" :class="{active: num == 0}"><common-data name="appShortName_40"/>介绍</li>
            <li @click="num = 1" :class="{active: num == 1}">功能介绍</li>
            <li @click="num = 2" :class="{active: num == 2}">购买须知</li>
            <!-- <li @click="num = 3" :class="{active: num == 3}">服务介绍</li> -->
        </ul>
        <div class="details_gn" v-show="num == 0">
            <p class="intent">
                文华财经旗下星格研究所的旗舰产品之一，面向商品研究机构和专业投资者，提供专业、准确、丰富、及时的商品数据与集成化、全流程的平衡表策略开发工具。
            </p>
            <p class="intent">
                商品数据方面，提供覆盖国内外期货品种的行情数据、产业数据、宏观数据、新闻资讯等。还提供多种专业分析工具，助力商品研究。
            </p>
            <p class="intent">
                平衡表策略方面，支持引用大宗商品的产业大数据，宏观、供给、需求、消费等因子，量化各类市场参与者的决策依据，仿真市场价格的形成机制，对各个商品做多因子分析，构建量化交易策略。
            </p>
            <p class="intent">
                wh10也内置了文华的AI大语言模型技术，引用文华财经的行业新闻数据库，AI技术做行情分析，撰写研究报告。
            </p>
            <div class="tips">安全提示：交易过程中请勿点击不明来源的链接，付款前请务必详细核对支付信息</div>
        </div>
        
        
        <div class="details_gn" v-show="num == 1">
            <p class="detail_title">10C套餐 </p>
            <p>1.商品数据库：提供包括国内80个商品的板块指数、供应端、需求端、库存、现货价格、基差、资金流向、宏观经济等近万个数据项；<br>
                2.平衡表策略研究：以宏观、供给、需求、消费各维度的价格影响因素构建平衡表，借期货因子对价格的影响仿真商品价格形成过程，探寻价格变动依据；<br>
                3.可视化分析图表：品种产业链、供需平衡表、现货价格走势、资金流向等多种可视化分析图表，海量、复杂的产业数据变得清晰、直观，影响价格的核心驱动因素一目了然；<br>
                4.Excel插件：通过插件工具可对系统数据库中的产业数据、宏观经济数据、商品行情做导出分析或者二次加工，生成报告、可视化分析；<br>
                5.自有数据落库：支持用户数据落库，在软件中分析维护，与系统库联合构建期货因子和策略；<br>
                6.AI投研：从海量数据中快速提取关键信息，基于专业商品投研视角，生成商品研报。
            </p>
            <p class="tent">* 本服务中必须提供的数据及信息仅限用户另外付费选配的范围；服务期内我司有权对其他数据及信息进行增、减等调整。</p>
            <a target="_blank" href="https://wh10.wenhua.com.cn/#/Buy">>>> 查看10C套餐更多功能</a>
            <div class="tips">安全提示：交易过程中请勿点击不明来源的链接，付款前请务必详细核对支付信息</div>
        </div>
        <div class="details_gn" v-show="num == 2">
            <p class="tent">1.付费成功后如无功能问题恕不退不换。</p>
            <p class="tent">2.购买前请先下载<a :href="downloadLink" target="_blank"><common-data name="appShortName_40"/></a>体验版了解软件基础功能。</p>
            <p class="tent" style='padding-left:12px;text-indent:-12px;'>
                3.使用<common-data name="appShortName_40"/>的电脑配置要求：<br />
                · X86架构的4核CPU/8G内存（RAM），或更高配置；<br />
                · windows10、windows11等64位操作系统；
            </p>
            <p class="tent">4.推荐南方地区使用电信网络，北方地区使用联通网络，其它网络使用效果不佳。</p>
            
            <div class="tips">安全提示：交易过程中请勿点击不明来源的链接，付款前请务必详细核对支付信息</div>
        </div>
    </div>
</template>
<script>
import Axios from 'axios';
    export default {
        data() {
            return {
                num: 2,
                downloadLink: ''
            }
        },
        mounted () {
            this.$axios({
                url: 'https://webapi.wenhua.com.cn/update/api/Update/GetUpdateInfo?appid=40',
                method: "get"
            }).then(res => {
                if (res.data.ResultData) {
                    let data = JSON.parse(res.data.ResultData)
                    this.downloadLink = 'https://ftpc1.wenhua.com.cn/files/' + data.Version
                }
            })
        }
    }
</script>
<style scoped>
@import url('./doc.css');
.details_gn{
    min-height: 255px;
}
</style>